import React from 'react';
import { Gift } from 'react-feather';
import { useIsEnrolledUser } from 'app/entity/user/userHooks';

interface OwnProps {
  rewardTabFilter: string;
}

const RewardEmptyState = (props: OwnProps) => {
  const { rewardTabFilter } = props;

  let InnerText: React.ReactNode = null;
  const isEnrolled = useIsEnrolledUser();

  if (rewardTabFilter === 'my-reward') {
    InnerText = (
      <>
        <p className="text-neutral-500">You don’t have any rewards now.</p>
        {!isEnrolled && (
          <p className="text-neutral-500">
            Join Seedly Rewards to redeem rewards!
          </p>
        )}
      </>
    );
  }

  if (rewardTabFilter === 'browse-reward') {
    InnerText = (
      <p className="text-neutral-500 text-center">
        There are no available rewards. <br /> Try resetting the filter to
        discover more rewards.
      </p>
    );
  }

  return (
    <div className="center-in-div h-[200px]">
      <div className="flex flex-col gap-4 items-center">
        <Gift size={64} className="text-neutral-500" />
        <div className="flex flex-col gap-1 items-center">{InnerText}</div>
      </div>
    </div>
  );
};

export default RewardEmptyState;
